import React from 'react';
import {View, Text, TouchableOpacity} from 'react-native';
import {useDispatch, useSelector} from 'react-redux';

import useWindowDimensionsSafe from 'src/Modules/Native/useWindowDimensionsSafe';

import {TopTab, TopTabButton} from 'src/Modules/TabViews';
import {
  setLocalFilters,
  updateLocalView,
} from '../Redux/reducers/local.reducer';

import LocalList from './LocalList';
import LocalMap from './LocalMap';
import LocalLeaderboard from './LocalLeaderboard';

import SearchBar from 'src/Modules/CommonView/SearchBar';
import {addLocationToGuide} from './localFunctions';
import {ButtonIcon} from 'src/Modules/ButtonMenu';
import {navigationRef} from '../Nav/navigationHelpers';

const LocalTab = () => {
  const {width} = useWindowDimensionsSafe();
  const localView = useSelector((state) => state.local.localView);

  const dispatch = useDispatch();
  const handleTopPress = (side) => {
    dispatch(updateLocalView(side));
  };

  const localFilters = useSelector((state) => state.local.localFilters);

  //
  console.log({localView});
  return (
    <View style={{flex: 1}}>
      <View
        style={{
          flexDirection: 'row',
          justifyContent: 'center',
          backgroundColor: 'white',
          zIndex: 1000,
        }}>
        <SearchBar
          containerStyle={{
            width: width - 70,
            backgroundColor: 'transparent',
            borderWidth: 0,
            borderBottomColor: 'transparent',
            borderTopColor: 'transparent',
            marginBottom: 10,
          }}
          searchIcon={{size: 16}}
          onChangeText={(text) => {
            const newLocalFilters = {
              ...localFilters,
              title: text,
            };
            dispatch(setLocalFilters(newLocalFilters));
          }}
          value={localFilters?.title}
          onClear={() => {
            const newLocalFilters = {
              ...localFilters,
              title: null,
            };
            dispatch(setLocalFilters(newLocalFilters));
            //setActiveSearch(false);
          }}
          icon={{name: 'search', size: 22, style: {top: 0, left: 20}}}
          inputStyle={{
            height: 35,
            fontSize: 14,
            backgroundColor: global?.color?.white1,
            borderRadius: 12,
            marginLeft: 10,
            color: global?.color?.gray3,
            marginRight: 5,
            paddingLeft: 30,
          }}
          placeholder="Search Local Sites"
        />
        <TouchableOpacity
          onPress={() => {
            navigationRef.navigate('LocalFilterModal');
          }}
          style={{
            height: 55,
            marginTop: 3,
            display: 'flex',
            justifyContent: 'center',
          }}>
          <Text style={{color: global?.color?.blue, lineHeight: 14}}>
            Filter{localFilters?.filter_count > 0 ? 's ' : ' '}
            <View
              style={{
                backgroundColor: global?.color?.blue,
                top: 2,
                height: 16,
                width: 16,

                borderRadius: 8,
              }}>
              <Text
                style={{
                  color: 'white',
                  fontSize: 12,

                  textAlign: 'center',
                  fontFamily: global?.font?.circular,
                }}>
                {localFilters?.filter_count || 0}
              </Text>
            </View>
          </Text>
        </TouchableOpacity>
      </View>
      <TopTab>
        <TopTabButton
          text={'List'}
          active={localView === 'list'}
          handlePress={() => handleTopPress('list')}
          index={0}
        />
        <TopTabButton
          text={'Map'}
          active={localView === 'map'}
          handlePress={() => handleTopPress('map')}
          index={1}
        />
        <TopTabButton
          text={'Leaderboard'}
          active={localView === 'leaderboard'}
          handlePress={() => handleTopPress('leaderboard')}
          index={2}
        />
      </TopTab>

      <View></View>
      <View style={{flex: 1}}>
        {!!(localView == 'list') && (
          <LocalList handleTopPress={handleTopPress} />
        )}
        {!!(localView == 'map') && <LocalMap handleTopPress={handleTopPress} />}
        {!!(localView == 'leaderboard') && (
          <LocalLeaderboard handleTopPress={handleTopPress} />
        )}
      </View>

      <ButtonIcon
        // buttonTitle={'Contribute'}
        buttonTitle={'Add Sites'}
        onPress={() => addLocationToGuide()}
        name={'plus'}
        style={{
          right: 10,
          bottom: 10,
          backgroundColor: 'transparent',
          position: 'absolute',
        }}
      />
    </View>
  );
};

export default LocalTab;
